// 不带小数的前分位表示法
export function toThousandsNoDecimal(num) {
    return Math.floor(num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
}

export function toThousands(num) {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
}